import React from 'react'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import {
  Typography,
  Link
} from '@mui/material'


const Navigation = () => {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 1rem',
        height: '54px',
        position: 'sticky',
        top: 0,
        zIndex: 1002,
        backgroundColor: 'var(--bg)'
      }}
    >
        <Link
          component={RouterLink}
          to="/"
          sx={{ 
            color: isActive('/') ? 'white' : '#ECEDFEFF', // Highlight if active
            fontWeight: isActive('/') ? 'bold' : 'normal', // Optional: make bold if active
          }}
          underline="hover"
        >
          <Typography sx={{ textAlign: 'left', fontFamily: "'Radar'", fontSize: '14px'}}>NORMAN PONTE</Typography>
        </Link>
        <div>
        <Link
          component={RouterLink}
          to="/about"
          sx={{
            color: isActive('/about') ? 'white' : '#ECEDFEFF', // Highlight if active
            fontWeight: isActive('/about') ? 'bold' : 'normal', // Optional: make bold if active
          }}
          underline="hover"
        >
          About
        </Link>
        <Link
          component={RouterLink}
          to="/notes"
          sx={{
            color: isActive('/notes') ? 'white' : '#ECEDFEFF', // Highlight if active
            fontWeight: isActive('/notes') ? 'bold' : 'normal', // Optional: make bold if active
          }}
          underline="hover"
        >
          Notes
        </Link>
        <Link
          component={RouterLink}
          to="/reviews"
          sx={{
            color: isActive('/reviews') ? 'white' : '#ECEDFEFF', // Highlight if active
            fontWeight: isActive('/reviews') ? 'bold' : 'normal', // Optional: make bold if active
          }}
          underline="hover"
        >
          Reviews
        </Link>
        </div>
    </div>
  )
}

export default Navigation
